import React, {memo, useCallback, useState} from 'react';
import {View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {useLocale} from '@redlink/assets/locale';
import {Space, Text, FilePicker} from '@redlink/components/atoms';
import {ImageUploaderItem} from '@redlink/components/molecules';
import {TemporaryUploader} from './temporaryUploader';

export const ImageGroupUploader = memo(
    ({style, images = [], onChange, title, require = false}) => {
        const {styles} = useStyle();

        const onRemoveItem = useCallback(
            (index) => {
                onChange([...images.slice(0, index), ...images.slice(index + 1)]);
            },
            [images, onChange]
        );

        const onAddItem = useCallback(
            (item) => {
                onChange([...images, item]);
            },
            [images, onChange]
        );

        return (
            <View style={[style, styles.container]}>
                <Text style={styles.placeholderText}>
                    {title}
                    {require && <Text style={styles.requireText}>*</Text>}
                </Text>
                <Space size={4}/>
                <ImageGroupUploaderAdd {...{onAddItem}} />
                {images.map(({id, thumbnailUrl}, index) => {
                    return (
                        <>
                            <ImageUploaderItem
                                status={ImageUploaderItem.status.selected}
                                onRemove={() => onRemoveItem(index)}
                                text={id}
                                thumbnale={thumbnailUrl}
                            />
                            <Space size={4}/>
                        </>
                    );
                })}
            </View>
        );
    }
);

const ImageGroupUploaderAdd = memo(({onAddItem}) => {
    const {dictionary} = useLocale();
    const [images, setImages] = useState([]);

    const onUpload = (file, item) => {
        onFailure(file);
        onAddItem(item);
    };

    const onFailure = (file) => {
        setImages((prev) => [...prev.filter((p) => p.name !== file.name)]);
    };

    return (
        <View>
            <FilePicker
                onChange={(files) => {
                    setImages([...Array.from(files), ...images]);
                }}
            >
                <ImageUploaderItem
                    placehoder={dictionary.notSelected}
                    status={ImageUploaderItem.status.none}
                />
            </FilePicker>
            <Space size={8}/>
            {images.map((file, index) => {
                return (
                    <>
                        <TemporaryUploader {...{file, onUpload, onFailure}} />
                        <Space size={4}/>
                    </>
                );
            })}
        </View>
    );
});

const useStyle = createUseStyle(({colors, shadow, size}) => ({
    container: {},
    placeholderText: {
        flex: 1,
        fontSize: 12,
        color: colors.gray21,
        textAlign: 'left',
        marginTop: 3,
    },
    requireText: {
        color: colors.red1,
        fontSize: 10,
        marginStart: 5,
    },
}));
